import axios from "axios";
import { useTokenStore } from "../store/TokenStore";
import { useMessageStore } from "../store/MessageStore";

interface IResponse {
	status: ResponseStatusType;
	message: string;
	data?: any;
}
type ResponseStatusType = "success" | "error";

const axiosClient = axios.create({
	// baseURL: `http://127.0.0.1:4001`,
	baseURL: `https://psp.cerberus-games.com/svc`,
	withCredentials: true,
});

export const ApiRequest = async (url: string, dataObject: any = {}) => {
	try {
		const { data } = await axiosClient.post<IResponse>(url, dataObject, {
			headers: {
				"Content-Type": "application/json",
				"Cache-Control": "no-cache",
				Authorization: `Bearer ${useTokenStore.getState().token}`,
			},
		});
		if (data?.message === "jwt_expired") {
			useTokenStore.getState().TokenReset();
			return;
		}
		useMessageStore.getState().addMessage(data.status, data.message);
		return data;
	} catch (error) {
		// console.log(error);
	}
};
